import { useCallback } from 'react';
import { useGenericModal } from '../..';
import { EditorModal, EditorModalProps } from './editor-modal';

export const useEditorModal = ({
  onClose: _onClose,
  ...props
}: Partial<EditorModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const onClose = useCallback(() => {
    _onClose?.();
    closeModal();
  }, [_onClose, closeModal]);

  const editorModal = (
    <EditorModal {...props} modalRef={modalRef} onClose={onClose} />
  );

  return {
    modalRef,
    editorModal,
    openModal,
    closeModal,
  };
};
